export const DateFormats = {
  // API / DB Formats
  ISO_DATETIME_MS: "YYYY-MM-DDTHH:mm:ss.sssZ",
  ISO_DATETIME: "YYYY-MM-DDTHH:mm:ssZ",
  ISO_DATETIME_MICROS: "YYYY-MM-DDTHH:mm:ss.SSSSSSZ",
  DB_DATE: "YYYY-MM-DD",
  DB_DATETIME: "YYYY-MM-DD HH:mm:ss",
  YEAR_MONTH: "YYYY-MM",

  // UI Display Formats - Date Only
  UI_DATE_SHORT: "DD/MM/YYYY",
  UI_DATE_SHORT_2Y: "DD/MM/YY",
  UI_DATE_LONG: "dddd, MMMM D, YYYY",
  UI_DATE_FULL: "dddd D MMMM YYYY",
  UI_DATE_MEDIUM: "D MMMM YYYY",

  // UI Display Formats - Time Only
  UI_TIME_SHORT: "HH:mm",
  UI_TIME_FULL: "HH:mm:ss",

  // UI Display Formats - DateTime
  UI_DATETIME_SHORT: "DD/MM/YYYY, HH:mm",
  UI_DATETIME_SHORT_2Y: "DD/MM/YY, HH:mm",
  UI_DATETIME_MEDIUM: "DD/MM/YYYY HH:mm",
  UI_DATETIME_FULL: "DD/MM/YYYY HH:mm:ss",

  // Special Purpose
  COMPACT_KEY: "YYMMDD",
  COMPACT_DATETIME: "YYMMDDHHmmss",
  FILE_NAME: "YYYY-MM-DD_HH-mm-ss",
};

export type DateFormat = (typeof DateFormats)[keyof typeof DateFormats];
